import { Action, createReducer, on } from "@ngrx/store";
import { Person } from "src/app/main/admin/referentials/person/shared/person.model";
import { LayoutConfig } from "src/app/main/layout/service/app.layout.service";
import { UserInfo } from "src/app/user/login/shared/user-info.model";
import { WcswState } from "src/app/user/login/shared/wcsw-state.model";
import { WcswOption } from "./../../user/login/shared/wcsw.model";
import { updateInputPersonId } from "./../actions/user.actions";
import {
  clearUserState,
  saveUserState,
  updateUserInfoFirstAndLastName,
  updateUserLayout,
  updateWcswState,
} from "../actions/user.actions";

export type UserState = {
  userInfo?: UserInfo;
  wcswState?: WcswState;
};

export const initialUserState: UserState = {};

const _userReducer = createReducer(
  initialUserState,
  on(saveUserState, (_state: UserState, newUser: UserState) => {
    return newUser;
  }),
  on(updateWcswState, (state: UserState, wcswState: WcswState) => {
    return {
      ...state,
      wcswState,
    };
  }),
  on(
    updateUserInfoFirstAndLastName,
    (state: UserState, payload: { firstName: string; lastName: string }) => {
      const newPerson: Person = {
        ...state.userInfo.person,
        firstName: payload.firstName,
        name: payload.lastName,
      };
      const newUserInfo: UserInfo = { ...state.userInfo, person: newPerson };

      return { ...state, userInfo: newUserInfo };
    },
  ),
  on(
    updateInputPersonId,
    (state: UserState, payload: { inputPerson: number }) => {
      const inputer: WcswOption = state.wcswState.flattenedPersons.find(
        (op) => op.id === payload.inputPerson,
      );
      const newWcswState: WcswState = {
        ...state.wcswState,
        inputPerson: inputer,
      };

      return { ...state, wcswState: newWcswState };
    },
  ),
  on(
    updateUserLayout,
    (state: UserState, payload: { layout: Partial<LayoutConfig> }) => {
      const newLayout = {
        ...state.userInfo?.layout,
        ...payload.layout,
      };
      const newUserInfo: UserInfo = {
        ...state.userInfo,
        layout: newLayout,
      };

      return { ...state, userInfo: newUserInfo };
    },
  ),
  on(clearUserState, () => ({})),
);

export function userReducer(state: UserState | undefined, action: Action) {
  return _userReducer(state, action);
}
